module.exports = __webpack_public_path__ + "static/img/popular.f9d64bf1.png";